<template>
  <div class="container p-4" style="min-height: 150px">

    <div style="text-align: justify; overflow-wrap: break-word"
      v-if="!customView && !isExpedientesComponent && !isFormComponent && !isBoxIconGridComponent">
      <div v-html="html"></div>
    </div>

    <div class="dinamic" v-if="this.customView != null">
      <component v-bind:is="this.customView"></component>
    </div>

    <FormComponent v-if="isFormComponent" />
    <ExpedientesComponent v-if="isExpedientesComponent" :filtros="{ site: 'dlc.siged.consulta.exp' }" />

    <popup-component v-if="isBoxIconGridComponent" :columnas="3" titulo="Sistemas Integrados" iconos-grandes="false"
      :index="0" :data="[
        {
          desc: null,
          icon: 'attach_money',
          target: '_blank',
          title: 'SIIF',
          contenido:
            'Sistema Integrado de Información Financiera: posibilita la gestión de procedimientos e información financiera que brinda información en línea sobre el presupuesto, la tesorería y los subsistemas contables, al mismo tiempo que facilita la generación oportuna de informes confiables sobre la ejecución presupuestaria',
        },
        {
          desc: null,
          icon: 'ptn-i-documento',
          target: '_blank',
          title: 'SIGED',
          contenido:
            'Sistema Integrado de Gestión Documental: permite el seguimiento de expedientes.',
        },
        {
          desc: null,
          icon: 'ptn-i-des-hum-pro-s',
          target: '_blank',
          title: 'SIPE',
          contenido:
            'Sistema Integrado de Personas: consta de un Padrón único de entidades físicas (registro civil) y jurídicas (IGPJ, Dirección de Cooperativas, Dirección de Mutualidades, Dirección de Culto y ONG, Registro Público de Comercio -Poder Judicial-), con el fin de proveer información certera y actualizada de personas a todos los sistemas de la Administración Pública que lo requieran.',
        },
        {
          desc: null,
          icon: 'ptn-i-des-hum-pro-s',
          target: '_blank',
          title: 'SIARH',
          contenido:
            'Sistema Integrado de Administración de Recursos Humanos: facilita la gestión de Legajos y todo lo que refiere a la trazabilidad de los agentes del estado impactando en la Liquidación de Haberes.',
        },
        {
          desc: null,
          icon: 'ptn-i-ipv',
          target: '_blank',
          title: 'IPV',
          contenido:
            'Sistema de Gestión Instituto Provincial de la Vivienda, posee la información desde la inscripción en la operatoria hasta la escrituración de la casa. Su integración al S.I.I.F. permite una registración financiera y contable de la obra.Su integración al S.I.G.O.P. posibilita un seguimiento completo del proceso de ejecución de la obra. La migración de datos históricos sirve de base para la confección de la Base de Datos del IPV.',
        },
        {
          desc: null,
          icon: 'ptn-i-centro-civ',
          target: '_blank',
          title: 'SIGOP',
          contenido:
            'Sistema Integrado de Gestión de Obra Pública: permite realizar un seguimiento completo de todo lo relacionado a la obra pública en sus etapas de proyecto, adjudicación, ejecución y su registración patrimonial, financiera y contable. En este sistema se realiza la carga de datos histórica para la confección de la Base de Datos de obras activas.',
        },
      ]" />

    <popup-component v-if="isBoxIconGridComponent" :columnas="3" titulo="Sistemas de Gestión" iconos-grandes="false"
      :index="6" :data="[
        {
          desc: null,
          icon: 'ptn-i-seguridad',
          target: '_blank',
          title: 'HALCON',
          contenido:
            'Sistema de control de personas en situación de conflicto con las reglamentaciones vigentes utilizado por Flagrancia y Patronato.',
        },
        {
          desc: null,
          icon: 'ptn-i-documento',
          target: '_blank',
          title: 'GAILT',
          contenido:
            'Sistema de Gestión de Actas por infracción a la Ley de Tránsito implementado en Juzgados de Faltas, Policía de Tránsito y Juzgados de Paz.',
        },
        {
          desc: null,
          icon: 'ptn-i-des-hum-pro-s',
          target: '_blank',
          title: 'ANDES',
          contenido: 'Sistema de historia clínica digital',
        },
        {
          desc: null,
          icon: 'ptn-i-centro-civ',
          target: '_blank',
          title: 'CONSUMAN',
          contenido: 'Sistema de Gestión y mantenimiento de Activos',
        },
        {
          desc: null,
          icon: 'trending_up',
          target: '_blank',
          title: 'BI',
          contenido:
            'La plataformas de BI es un software que permite recopilar datos pasados, futuros y actuales, procesar, analizar y obtener estadísticas.',
        },
        {
          desc: null,
          icon: 'ptn-i-documento',
          target: '_blank',
          title: 'BPM',
          contenido:
            'Gestión de procesos de negocio es una herramienta de software utilizada para mejorar los procesos de una organización a través de la definición, automatización y análisis de procesos.',
        },
        {
          desc: null,
          icon: 'auto_stories',
          target: '_blank',
          title: 'RCDIGITAL',
          contenido: 'Sistema de Gestión del Registro Civil',
        },
        {
          desc: null,
          icon: 'ptn-i-des-hum-pro-s',
          target: '_blank',
          title: 'RUNMEPI',
          contenido: 'Registro Único Nominal de medidas de protección integral',
        },
      ]" />

    <popup-component v-if="isBoxIconGridComponent" :columnas="3" titulo="Sistema de Liquidación de haberes"
      iconos-grandes="false" :index="14" :data="[
        {
          desc: null,
          icon: 'ptn-i-documento',
          target: '_blank',
          title: 'Novedades de Sueldos',
          contenido:
            'Sistema para el ingreso de novedades informadas por período de liquidación.',
        },
        {
          desc: null,
          icon: 'ptn-i-des-hum-pro-s',
          target: '_blank',
          title: 'Liquidación de Haberes',
          contenido:
            'Sistema de liquidación de sueldos que incluye la determinación de impuesto a las ganancias, prorrateo de descuentos, emisión de planillas y recibo de haberes.',
        },
        {
          desc: null,
          icon: 'ptn-i-documento',
          target: '_blank',
          title: 'Histórico de Sueldos',
          contenido:
            'Sistema que permite acceder a la consulta histórica de liquidaciones de Agentes de la Administración Pública Provincial.',
        },
      ]" />

    <BoxIconGridComponent v-if="isBoxIconGridComponent" :columnas="3" iconos-grandes="false" titulo="Accesos" :data="[
      {
        desc: null,
        icon: 'calendar_month',
        target: '_blank',
        title: 'TURNERO',
        url: 'https://turnos.sanjuan.gob.ar/',
      },

      {
        desc: null,
        icon: 'ptn-i-documento',
        target: '_blank',
        title: 'DIGESTO JURIDICO',
        url: 'https://digestosanjuan.gob.ar/home',
      },
      {
        desc: null,
        icon: 'ptn-i-documento',
        target: '_blank',
        title: 'DIGESTO ADMINISTRATIVO',
        url: 'https://digesto.sanjuan.gob.ar/digesto/',
      },
      {
        desc: null,
        icon: require('@/assets/iconos/mapa.png'),
        target: '_blank',
        title: 'UNIDE',
        url: 'https://web.sanjuan.gob.ar/unide/',
      },
    ]" />

    <BoxIconGridComponent v-if="isBoxIconGridComponent" :columnas="3" titulo="Sitios Web" :data="[
      {
        desc: null,
        icon: 'ptn-i-ciudadano-digital',
        target: '_blank',
        title: 'CIUDADANO DIGITAL',
        url: 'https://cidi.sanjuan.gob.ar/',
      },
      {
        desc: null,
        icon: require('@/assets/iconos/task.png'),
        target: '_blank',
        title: 'VALIDACIÓN DE COMPROBANTES',
        url: 'https://validacion.sanjuan.gob.ar/',
      },
      {
        desc: null,
        icon: 'ptn-i-gob-sj',
        target: '_blank',
        title: 'COMPRAS PÚBLICAS',
        url: 'https://compraspublicas.sanjuan.gob.ar/',
      },
    ]" />


    <div class="text-center pt-4">
      <p>
        <button v-on:click="back" class="btn btn-secondary text-uppercase">
          Volver
        </button>
      </p>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import PopupComponent from "./components/resources/PopupComponent.vue";
import ExpedientesComponent from "./components/resources/ExpedientesComponent.vue";
import FormComponent from "./components/resources/FormComponent.vue";

export default {
  name: "InfoView",
  props: {
    uid: String,
    filtros: Object,
  },
  data() {
    return {
      html: null,
      isBoxIconGridComponent: false,
      customView: false,
      isExpedientesComponent: false,
      isFormComponent: false,
    };
  },
  methods: {
    back: function () {
      history.back();
    },
  },
  mounted() {
    if (this.uid === "CUMV-VIEW-BoxIconGridComponent") {
      this.isBoxIconGridComponent = true;
    }
    else if (this.uid === "CUMV-VIEW-ExpedientesComponent") {
      this.isExpedientesComponent = true;
    }
    else if (this.uid === "CUMV-VIEW-FormComponent") {
      this.isFormComponent = true;
    }
    else if (this.uid.includes("CUMV-"))
      switch (this.uid) {
        case "CUMV-CatalogodeAplicacionesyServicios": {
          this.html = `<section class="container">
    <div>
      <h1 class="pb-5">Aplicaciones y Servicios</h1>

      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne">
              Owncloud/NextCloud
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Documentos <br />
              <strong>Alcance:</strong> Colaboración y Cloud Interno
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwo"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTwo">
              SIIF - Sistema Integrado de Información Financiera
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingTwo">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión Financiera <br />
              <strong>Alcance:</strong> Gestión de procedimientos e información
              financiera, y brinda información en línea sobre el presupuesto, la
              tesorería y los subsistemas contables, al mismo tiempo que
              facilita la generación oportuna de informes confiables sobre la
              ejecución presupuestaria
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseThree"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseThree">
              Redmine
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingThree">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Proyectos de
              Tecnología <br />
              <strong>Alcance:</strong> Herramienta de gestión de proyectos
              estándar agnóstica con la posibilidad de personalizar la con
              metodologías de gestión o utilizarla para gestionar incidencias o
              peticiones a distintas áreas. actualmente está disponible para
              todas las reparticiones a través de redmine.sanjuan. gov. ar
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseFive"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseFive">
              ANDES
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingFive">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Identidades <br />
              <strong>Alcance:</strong> Historia clínica digital
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseSix"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseSix">
              SIPE - Sistema Integrado de Personas
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingSix">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Identidades <br />
              <strong>Alcance:</strong> Padrón único de entidades físicas
              (registro civil) y jurídicas (igpj, dirección de cooperativas,
              dirección de mutualidades, dirección de culto y ong, Registro
              Público de Comercio (Poder Judicial)). Proveer información certera
              y actualizada de personas a todos los sistemas de la
              Administración Pública que lo requieran.
            </div>
          </div>
        </div>        

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingEight">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseEight"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseEight">
              SOA
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseEight"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingEight">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Integraciones
              <br />
              <strong>Alcance:</strong> Proyecto de interoperabilidad entre
              sistemas cuyo concepto Central es intentar modificar lo menos
              posible los sistemas Y lograr lo máximo posible de integración en
              una capa de servicios a nivel de aplicaciones. perfeccionando el
              uso de estándares en autenticación y utilización de servicios y en
              la metodología de creación de los mismos. sinovial la flexibilidad
              de adaptarse a los clientes ya que somos conscientes de que hay
              una distribución tecnológica importante a la que hay que dar
              soporte de integración. en este proyecto el gran esfuerzo es la
              definición de objetos de negocio y de reglas intrasistemas y luego
              la aplicación dentro de una plataforma a nivel mundial de Oracle
              por lo que no implica desarrollos alentandonos a un crecimiento
              más veloz y estándar.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingTen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTen"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTen">
              CONSUMAN
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTen"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingTen">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Activos <br />
              <strong>Alcance:</strong> Sistema de gestion de activos
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingEleven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseEleven"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseEleven">
              SIGED - Sistema Integrado de Gestión Documental
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseEleven"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingEleven">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Documentos <br />
              <strong>Alcance:</strong> Sistema de Gestión Documental
              (Seguimiento de expedientes)
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingTwelve">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwelve"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTwelve">
              SIGE - Sistema de Gestión Educativa
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTwelve"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingTwelve">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión Eductiva <br />
              <strong>Alcance:</strong> Sistema de Gestión Educativa.
              Administración de Ministerio, Establecimientos, Junta de
              Clasificación y Soporte de Liquidación de Haberes.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingThirteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseThirteen"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseThirteen">
              SIARH - Sistema Integrado de Administración de Recursos Humanos
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseThirteen"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingThirteen">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Capital Humano
              <br />
              <strong>Alcance:</strong> Sistema Integrado de Recursos Humanos.
              Gestión de Legajos y todo lo que refiere a la trazabilidad de los
              agentes del estado impactando en la Liquidación de Haberes.
              Administración de Legajos y armas policiales. Gestión de
              adicionales de la Policía de San Juan.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingFiveteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseFiveteen"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseFiveteen">
              IPV - Sistema Integrado del Instituto Provincial de la Vivienda
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseFiveteen"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingFiveteen">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Vivienda <br />
              <strong>Alcance:</strong> Sistema integral de la operatoria del
              IPV. Desde la inscripción en la operatoria hasta la escrituración
              de la casa. Integración al SIIF permitiendo una registración
              financiera y contable de la obra. Integración al SIGOP,
              permitiendo un seguimiento completo del proceso de ejecución de la
              obra. Migración de datos históricos para confección de la Base de
              Datos del IPV.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingSixteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseSixteen"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseSixteen">
              SIGOP - Sistema Integrado de Obra Pública
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseSixteen"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingSixteen">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Obra Pública
              <br />
              <strong>Alcance:</strong> Sistema integral que permita realizar un
              seguimiento completo de todo de la obra pública desde el proyecto,
              adjudicación, ejecución y su registración patrimonial. Integración
              al SIIF permitiendo una registración financiera y contable de la
              obra. Supervisar la carga de datos histórica para la confección de
              la Base de Datos de obras activas.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingEighteen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseEighteen"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseEighteen">
              RC Digital
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseEighteen"
            class="accordion-collapse collapse"
            aria-labelledby="panelsStayOpen-headingEighteen">
            <div class="accordion-body">
              <strong>Proceso de Negocio:</strong> Gestión de Identidades
              <br />
              <strong>Alcance:</strong> Sistema de Gestión de Registro Civil
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


    </div>
  </section>`;
          break;
        }
      }
    else {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.uid = this.uid;

      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.html = response.data ? response.data.html : null;
          localStorage.setItem(this.uid, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Linea");
            if (localStorage.getItem(this.uid)) {
              console.log("Cargando elementos de cache para " + this.uid);
              var resp = JSON.parse(localStorage.getItem(this.uid));
              this.html = resp.data ? resp.data.html : null;
            }
          }
        });
    }
  },
  components: { BoxIconGridComponent, PopupComponent, ExpedientesComponent, FormComponent },
};
</script>

